<div class="page-container">
  @if (client$ | async; as clientResult) {
    <app-toolbar [title]="('COMMON.ADMIN' | translate) + (clientResult.data ? ' — ' + clientResult.data.name : '')"></app-toolbar>

    <div class="page">
      <div class="client-dashboard">
        @if (clientResult.isSuccess) {
          @if (teams$ | async; as teams) {
            @if (selectedTeamIds$ | async; as selectedTeamIds) {
              @if (teams.length > 1) {
                <div class="filters">
                  <app-multi-filter
                    [name]="'teamFilter'"
                    [idKey]="'id'"
                    [labelTranslationKey]="'COMMON.TEAMS'"
                    [icon]="'apartment'"
                    [fontSet]="null"
                    [values]="selectedTeamIds"
                    [options]="teams"
                    [displayWith]="displayTeam"
                    [displaySelected]="displaySelectedTeams(teams)"
                    (valueChange)="onTeamChange($event)"
                    (clear)="onTeamClear()"
                  ></app-multi-filter>
                </div>
              }

              @if (currentUser$ | async; as user) {
                <app-analytics-dashboard
                  [teamIds$]="teamIds$"
                  [dashboardUrl]="user.team.client.dashboardUrl"
                  [subscriptionUsage$]="subscriptionUsage$"
                  [showAudioMetrics]="true"
                ></app-analytics-dashboard>
              }
            }
          }
        } @else if (clientResult.isLoading) {
          <app-spinner></app-spinner>
        } @else if (clientResult.isError) {
          <h2 class="failed-to-load">{{ 'COMMON.FAILED_TO_LOAD' | translate }}</h2>
        }
      </div>
    </div>
  }
</div>
